import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Copy18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.61111 1.25C4.85939 1.25 4.25 1.85939 4.25 2.61111L4.25 12.3889C4.25 13.1406 4.85939 13.75 5.61111 13.75H15.3889C16.1406 13.75 16.75 13.1406 16.75 12.3889V2.61111C16.75 1.85939 16.1406 1.25 15.3889 1.25H5.61111ZM5.75 12.25V2.75L15.25 2.75V12.25H5.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 5V15.25H13V16.75H2.5C1.80964 16.75 1.25 16.1904 1.25 15.5V5H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Copy18.displayName = 'Copy18';
export default Copy18;
